// extracted by mini-css-extract-plugin
export var colContainer = "ReliableSDS-module--colContainer--1xgsL";
export var section = "ReliableSDS-module--section--8qsE6";